import {
    apiRequest,
    awardExceptionDetail,
    awardExceptionCreate,
    awardExceptionUpdate,
} from "../../../../../services/adapters/master/awardExceptionService"

class IndexRepository {

    fetchDetail = async (query) => {
        return await apiRequest("get", awardExceptionDetail, {
            params: query
        }, true)
    }

    fetchUpdate = async (query) => {
        return await apiRequest("post", awardExceptionUpdate, {
            body: query
        }, true)
    }

    fetchCreate = async (query) => {
        return await apiRequest("post", awardExceptionCreate, {
            body: query
        }, true)
    }

}

export default IndexRepository